import React, { Fragment } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const Package = () => {

    return (
        <Fragment>
            <Header />

            <div className="breadcumb-wrapper" style={{ background: "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),  url('/assets/img/added/ban.jpg')" }}>
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">Tours Packages</h1>
                        <div className="breadcumb-menu-wrap">
                            <ul className="breadcumb-menu">
                                <li><a href="index.html">Home</a></li>
                                <li>Tours Packages</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <section className="space space-bottom">
                <div className="outer-wrap">
                    <div className="container">
                        <div className="shadow-content1">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="row filter-active tours-active">
                                        <div className="col-xl-4 col-lg-6 col-sm-6 filter-item hightTolow">
                                            <div className="package-style1">
                                                <div className="package-img">
                                                    <img src="assets/img/added/pack-8.png" alt="Package" />
                                                </div>
                                                <div className="package-content">
                                                    <h3 className="package-title"><a href="assets/pdf/9_Days_Special_Gujarat_Package.pdf" target="_blank">9 days special package</a></h3>
                                                    <p className="package-text">Gujarat Tour</p>
                                                    <div className="package-footer">
                                                        <a href="assets/pdf/9_Days_Special_Gujarat_Package.pdf" target="_blank" className="vs-btn">View Details</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-lg-6 col-sm-6 filter-item hightTolow">
                                            <div className="package-style1">
                                                <div className="package-img">
                                                    <img src="assets/img/added/pack-2.png" alt="Package" />
                                                </div>
                                                <div className="package-content">
                                                    <h3 className="package-title"><a href="assets/pdf/organic_tours_char_dham_yatra.pdf" target="_blank">Char Dham Yatra</a></h3>
                                                    <p className="package-text">Yamunotri, Gangotri, Kedarnath, Badrinath</p>
                                                    <div className="package-footer">
                                                        <a href="assets/pdf/organic_tours_char_dham_yatra.pdf" target="_blank" className="vs-btn">View Details</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-lg-6 col-sm-6 filter-item hightTolow">
                                            <div className="package-style1">
                                                <div className="package-img">
                                                    <img src="assets/img/added/pack-3.png" alt="Package" />
                                                </div>
                                                <div className="package-content">
                                                    <h3 className="package-title"><a href="assets/pdf/organic_Tours_India_North_Pilgrimage.pdf" target="_blank">North Pilgrimage tour</a></h3>
                                                    <p className="package-text"><span>Available on special request</span></p>
                                                    <div className="package-footer">
                                                        <a href="assets/pdf/organic_Tours_India_North_Pilgrimage.pdf" target="_blank" className="vs-btn">View Details</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        

                                        <div className="col-xl-4 col-lg-6 col-sm-6 filter-item hightTolow">
                                            <div className="package-style1">
                                                <div className="package-img">
                                                    <img src="assets/img/added/pack-5.png" alt="Package" />
                                                </div>
                                                <div className="package-content">
                                                    <h3 className="package-title"><a href="assets/pdf/Explore_India_Organic_Tours.pdf" target="_blank">Rajasthan and Kerala</a></h3>
                                                    <br /><br />
                                                    <div className="package-footer">
                                                        <a href="assets/pdf/Explore_India_Organic_Tours.pdf" target="_blank" className="vs-btn">View Details</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-xl-4 col-lg-6 col-sm-6 filter-item hightTolow">
                                            <div className="package-style1">
                                                <div className="package-img">
                                                    <img src="assets/img/added/coming-soon.png" alt="Package" style={{ height: "446px" }} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-xl-4 col-lg-6 col-sm-6 filter-item hightTolow">
                                            <div className="package-style1">
                                                <div className="package-img">
                                                    <img src="assets/img/added/pack-4.png" alt="Package" />
                                                </div>
                                                <div className="package-content">
                                                    <h3 className="package-title"><a href="assets/pdf/organic_Tours_India_North_Pilgrimage.pdf" target="_blank">Char Dham Bharat</a></h3>
                                                    <p className="package-text">Dwarka, Jagannath Puri, Rameswaram and Badrinath</p>
                                                    <div className="package-footer">
                                                        <a className="vs-btn">Coming Soon</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="vs-pagination pt-lg-2">
                                        <ul>
                                            <li><a href="/contact"><i className="fas fa-chevron-left" /></a></li>
                                            <li><a href="/contact">1</a></li>
                                            <li><a href="/contact">2</a></li>
                                            <li><a href="/contact">3</a></li>
                                            <li><a href="/contact"><i className="fas fa-chevron-right" /></a></li>
                                        </ul>
                                    </div> */}
                                </div>
                                {/* <div className="col-lg-3">
                                    <div className="sidebar-area tours-sidebar">
                                        <div className="widget">
                                            <form className="booking-form">
                                                <div className="form-group ">
                                                    <i className="fas fa-search" />
                                                    <input type="text" placeholder="Search Tour" />
                                                </div>
                                                <div className="form-group ">
                                                    <i className="fas fa-compass" />
                                                    <input type="text" placeholder="Where To?" />
                                                </div>
                                                <div className="form-group">
                                                    <i className="fas fa-calendar-alt" />
                                                    <select className="form-select" name="name">
                                                        <option value selected="selected" disabled="disabled" hidden>
                                                            Select Month</option>
                                                        <option value>January</option>
                                                        <option value>February</option>
                                                        <option value>March</option>
                                                        <option value>April</option>
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <i className="fas fa-thumbtack" />
                                                    <select className="form-select" name="name">
                                                        <option value selected="selected" disabled="disabled" hidden>
                                                            Select Type</option>
                                                        <option value>Adventure </option>
                                                        <option value>Combining</option>
                                                        <option value>Sporting</option>
                                                        <option value>Domestic</option>
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <div className="chekbox-area">
                                                        <input type="radio" id="popular" name="fav_language" defaultValue="popular" defaultChecked />
                                                        <label htmlFor="popular">Popular</label>
                                                    </div>
                                                    <div className="chekbox-area">
                                                        <input type="radio" id="trendy" name="fav_language" defaultValue="trendy" />
                                                        <label htmlFor="trendy">Trendy</label>
                                                    </div>
                                                    <div className="chekbox-area">
                                                        <input type="radio" id="latest" name="fav_language" defaultValue="latest" />
                                                        <label htmlFor="latest">Latest</label>
                                                    </div>
                                                </div>
                                                <button className="vs-btn style4 w-100">Search</button>
                                            </form>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <Footer />
        </Fragment>
    );
}

export default Package;